import React from 'react';

import { Alert, AlertTitle } from '@material-ui/lab';
import { IconButton, Snackbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { ErrorIcon } from 'components/CustomIcons';

import { BoxContainer } from './style';

const CLOSE_DELAY = 5000;

interface AlertDialogProps {
  setShowError: (val: boolean) => void;
  showError: boolean;
}

export default function AlertDialog({
  setShowError,
  showError,
}: AlertDialogProps) {
  return (
    <BoxContainer>
      <Snackbar
        open={showError}
        onClose={() => setShowError(false)}
        autoHideDuration={CLOSE_DELAY}
      >
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setShowError(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          icon={<ErrorIcon style={{ width: '0.75em', height: '0.75em' }} />}
        >
          <AlertTitle>Changes couldn&apos;t be saved</AlertTitle>
          Please make sure all of the field are filled.
        </Alert>
      </Snackbar>
    </BoxContainer>
  )
}
